import styled from "styled-components";

export const StyledInput = styled.input`
  height: 40px;
  width: 100%;
  padding: 10px;
  border: 1px solid #bdc2ca;
  border-radius: 4px;
  color: #63636d;
  font-size: 16px;
`;

export const Header = styled.div`
  margin-bottom: 10px;
  color: #63636d;
  font-size: 14px;
  font-weight: 400;
`;

export const Container = styled.div`
  margin: 0;
`;

export const Icon = styled.span`
  color: #63636d;
  margin: 0 5px;
`;

export const Input = styled.div`
  display: flex;
  align-items: center;
  .SingleDatePicker {
    width: 75%;
    .SingleDatePickerInput__withBorder {
      border-radius: 4px;
      .DateInput_input {
        border-radius: 4px;
        font-size: 15px;
        line-height: 18px;
      }
    }
  }
`;

export const StyledSelect = styled.select`
  height: 40px;
  width: calc(25% - 5px);
  padding: 10px;
  border: 1px solid #bdc2ca;
  border-radius: 4px;
  color: #63636d;
  font-size: 16px;
  margin-left: 5px;
  text-indent: ${(props) => (props.indent ? props.indent : "0")};
`;

export const Validation = styled.div`
  width: 100%;
  color: grey;
  font-size: 12px;
  line-height: auto;
  margin: 0;
  padding-left: 5px;
  margin-bottom: 1%;
  overflow: visible;
  white-space: wrap;
`;
